import * as _ from 'lodash';

export const toLabel = (value: string) => {
    const withSpaces = value.replace(/([A-Z])/g, ' $1');
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
};

export const monthAbbreviations = {
    'Jan': '01',
    'Feb': '02',
    'Mar': '03',
    'Apr': '04',
    'May': '05',
    'Jun': '06',
    'Jul': '07',
    'Aug': '08',
    'Sep': '09',
    'Oct': '10',
    'Nov': '11',
    'Dec': '12'
};

export const monthValueToFormattedMonth = (value: string) => {
    if (value.length > 4) {
        return _.invert(monthAbbreviations)[value.substr(0, 2)] + ' ' + value.substr(3);
    }
    return value;
};

export const formattedMonthToMonthValue = (formattedMonth: string) => {
    if (formattedMonth.length > 4) {
        return `${monthAbbreviations[formattedMonth.substr(0, 3)]}/${formattedMonth.substr(4)}`;
    }
    return formattedMonth;
};

export const toTitleCase = (value: string) => value.replace(/\w\S*/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase() ));
